function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown } from 'antd';
import { UserOutlined, BgColorsOutlined, LogoutOutlined } from '@ant-design/icons';
import { ThemeSwitcherModal } from './ThemeSwitcherModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Sider = Layout.Sider,
  Content = Layout.Content,
  Header = Layout.Header;
var BORDER_STYLE = '1px solid var(--theme-border)';

/**
 * Canonical AFM app shell. Both tenant-console and
 * vendor-console mount this so the platform feels like one product.
 *
 * Visual conventions (matches the Silver/Gold tenant look):
 *   • Collapsible left sider with gradient background and brand icon.
 *   • Profile avatar pinned at the bottom of the sider.
 *   • Optional top header for page-level actions (e.g. tenant chat
 *     toolbar). Set `header` to null to hide.
 *
 * All visual tokens come from CSS variables (`--theme-*`) populated by
 * the shared `ThemeProvider`.
 *
 * Props:
 *   brandIcon          — React node rendered at top of sider (logo).
 *   menuItems          — antd Menu items (use `path` for navigation).
 *   selectedKeys       — antd Menu selectedKeys.
 *   onMenuClick        — ({ key, item, keyPath, domEvent }) => void.
 *                        If the clicked item has a string `path`,
 *                        callers typically `navigate(path)`.
 *   collapsed          — controlled collapsed state. If undefined,
 *                        the shell is permanently icon-only (64px).
 *   onCollapse         — toggle handler when `collapsed` is controlled.
 *   userBadge          — { label, sublabel } shown above the user
 *                        dropdown in the menu (e.g. email + role).
 *   userMenuExtras     — additional items injected ABOVE the
 *                        standard "Theme" + "Logout" entries.
 *   onLogout           — required logout handler.
 *   header             — optional React node rendered as page header.
 *   children           — page body.
 */
export var AppShell = _ref => {
  var brandIcon = _ref.brandIcon,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    _ref$selectedKeys = _ref.selectedKeys,
    selectedKeys = _ref$selectedKeys === void 0 ? [] : _ref$selectedKeys,
    onMenuClick = _ref.onMenuClick,
    collapsed = _ref.collapsed,
    onCollapse = _ref.onCollapse,
    userBadge = _ref.userBadge,
    _ref$userMenuExtras = _ref.userMenuExtras,
    userMenuExtras = _ref$userMenuExtras === void 0 ? [] : _ref$userMenuExtras,
    onLogout = _ref.onLogout,
    _ref$header = _ref.header,
    header = _ref$header === void 0 ? null : _ref$header,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showThemeModal = _useState2[0],
    setShowThemeModal = _useState2[1];
  var isControlled = typeof collapsed === 'boolean';
  var isCollapsed = isControlled ? collapsed : true;
  var userMenuItems = [...(userBadge ? [{
    key: '__user_badge',
    disabled: true,
    label: /*#__PURE__*/_jsxs("div", {
      style: {
        lineHeight: 1.3,
        padding: '4px 0'
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          fontWeight: 600,
          color: 'var(--theme-textPrimary)'
        },
        children: userBadge.label
      }), userBadge.sublabel && /*#__PURE__*/_jsx("div", {
        style: {
          fontSize: 11,
          opacity: 0.7,
          color: 'var(--theme-textSecondary)'
        },
        children: userBadge.sublabel
      })]
    })
  }, {
    type: 'divider'
  }] : []), ...userMenuExtras, {
    key: '__theme',
    icon: /*#__PURE__*/_jsx(BgColorsOutlined, {}),
    label: 'Theme',
    onClick: () => setShowThemeModal(true)
  }, {
    key: '__logout',
    icon: /*#__PURE__*/_jsx(LogoutOutlined, {}),
    label: 'Logout',
    onClick: onLogout
  }];
  return /*#__PURE__*/_jsxs(Layout, {
    style: {
      height: '100vh',
      overflow: 'hidden'
    },
    children: [/*#__PURE__*/_jsxs(Sider, {
      trigger: null,
      collapsible: true,
      collapsed: isCollapsed,
      onCollapse: onCollapse,
      width: isControlled ? 220 : 64,
      collapsedWidth: 64,
      style: {
        position: 'relative',
        height: '100vh',
        overflow: 'visible',
        background: 'var(--theme-sidebarGradient)',
        borderRight: BORDER_STYLE
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          padding: '16px 0',
          borderBottom: BORDER_STYLE,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        children: brandIcon
      }), /*#__PURE__*/_jsx(Menu, {
        mode: "inline",
        inlineCollapsed: isCollapsed,
        selectedKeys: selectedKeys,
        onClick: onMenuClick,
        items: menuItems,
        style: {
          height: 'calc(100vh - 120px)',
          overflowY: 'auto',
          overflowX: 'visible',
          border: 'none',
          background: 'transparent',
          // Pin the Menu to the sider width when collapsed. Without
          // this AntD lets the inline menu compute an `auto` width
          // and items render off-centre / clipped (matches the
          // exact value tenant-console uses).
          width: isCollapsed ? 64 : undefined
        }
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: 'absolute',
          bottom: 16,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderTop: BORDER_STYLE,
          paddingTop: '16px'
        },
        children: /*#__PURE__*/_jsx(Dropdown, {
          menu: {
            items: userMenuItems
          },
          placement: "rightBottom",
          trigger: ['click'],
          children: /*#__PURE__*/_jsx(Avatar, {
            style: {
              background: 'var(--theme-logoGradient)',
              cursor: 'pointer'
            },
            icon: /*#__PURE__*/_jsx(UserOutlined, {})
          })
        })
      })]
    }), /*#__PURE__*/_jsx(ThemeSwitcherModal, {
      open: showThemeModal,
      onClose: () => setShowThemeModal(false)
    }), /*#__PURE__*/_jsxs(Layout, {
      style: {
        height: '100vh'
      },
      children: [header && /*#__PURE__*/_jsx(Header, {
        style: {
          background: 'var(--theme-headerBg)',
          borderBottom: BORDER_STYLE,
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 60,
          lineHeight: '60px'
        },
        children: header
      }), /*#__PURE__*/_jsx(Content, {
        style: {
          overflow: 'auto',
          height: header ? 'calc(100vh - 60px)' : '100vh',
          background: 'var(--theme-contentBg)'
        },
        children: children
      })]
    })]
  });
};